// extracted by mini-css-extract-plugin
export var action = "fc-video-module--action--1596d";
export var active = "fc-video-module--active--5a99e";
export var copy = "fc-video-module--copy--5404e";
export var copyBlock = "fc-video-module--copyBlock--57f8d";
export var cover = "fc-video-module--cover--984e2";
export var inner = "fc-video-module--inner--b1d3a";
export var player = "fc-video-module--player--874ae";
export var root = "fc-video-module--root--ba339";
export var title = "fc-video-module--title--84e64";
export var video = "fc-video-module--video--b9011";